import { Component, OnInit, ViewChild, forwardRef, OnDestroy, AfterViewInit } from '@angular/core';
import { InfoService } from '@app/core/info/info.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ICertificateData } from '@app/certificates/manage/manage';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Store } from '@ngrx/store';
import { ActionProfilePlanGet } from '@app/profile/profile-remaining-count/profile-plan.actions';

@Component({
  selector: 'cloud-manage-page',
  templateUrl: './manage-page.component.html',
  styleUrls: ['./manage-page.component.scss'],
})
export class ManagePageComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(forwardRef(() => MatExpansionPanel)) panel: MatExpansionPanel;

  unsubscribe$: Subject<void> = new Subject<void>();
  expandList = false;
  selectedCert: ICertificateData;
  showDeviceList = false;
  isSubcomponent = false;

  constructor(
    public info: InfoService,
    private store: Store<any>,
  ) {
    this.store.dispatch(new ActionProfilePlanGet());
  }

  ngOnInit() {

  }

  /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */
  ngAfterViewInit() {
    try {
      this.panel.expandedChange
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(open => {
          (open)
            ? setTimeout(() => { this.showDeviceList = true; }, 250)
            : this.showDeviceList = false;
        });
    } catch (e) { }
  }

  onShowDevices(cert: ICertificateData) {
    this.info.dismissAll();
    this.selectedCert = cert;
    this.showDeviceList = true;
    this.expandList = true;

    if (cert === null) {
      this.showDeviceList = false;
      this.expandList = false;
    } else {
    if (!this.panel.expanded) {
      this.showDeviceList = false;
      this.panel.open();
    }
  }

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
